
import { Vue, Component, } from 'vue-property-decorator'
import OverlayBackground from "@/components/OverlayBackground/Index.vue"

@Component({
  components: {OverlayBackground},
  computed: {},
})
export default class StepTwo extends Vue {
  private loading = false;

  private requestReview () {
    this.loading = true
    this.$mixpanel.track('Solicitar Revision', {'Actividad': this.$store.state.ActivitiesModule.ActivitiesState.SelectedActivity.name,})
    this.$store.dispatch('SteppersModule/requestReview', this.$route.params.task_id).then(() => {
      this.loading = false
      this.$emit('refresh')
    })
  }

  private requestBack () {
    this.loading = true
    this.$mixpanel.track('Cancelar Step 2', {'Actividad': this.$store.state.ActivitiesModule.ActivitiesState.SelectedActivity.name,})
    this.$store.dispatch('SteppersModule/requestBack', this.$route.params.task_id).then(() => {
      this.loading = false
      this.$emit('refresh')
    })
  }
}
